import { Form } from "react-bootstrap";
import cloneDeep from "lodash/cloneDeep";
import React, { useCallback, useMemo, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import InputGroup from "../../witadmin/CRUD/Common/InputGroup";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { WitLabel } from "./common";

const messages = defineMessages({
    accessLimit: {
        id: "loyaltyTier.accessLimit",
        defaultMessage: "accessLimit",
    },
    numberReservations: {
        id: "loyaltyTier.numberReservations",
        defaultMessage: "numberReservations",
    },
    sumAmount: {
        id: "loyaltyTier.sumAmount",
        defaultMessage: "sumAmount",
    },
    applicableCriteria: {
        id: "loyaltyTier.applicableCriteria",
        defaultMessage: "applicableCriteria",
    },
    both: {
        id: "loyaltyTier.both",
        defaultMessage: "both",
    },
});

export function LoyaltyTierConditions({
    formData,
    onChange,
    rawErrors,
    disabled,
    id,
    schema
}: FieldProps) {
    const intl = useIntl();
    const currency = "EUR";
    const initialSumAmount = useMemo(
        () =>
            formData.conditionsList &&
            formData.conditionsList[0] &&
            formData.conditionsList[0]["spentAmountCondition"],
        [formData]
    );
    const initialNumberReservations = useMemo(
        () =>
            formData.conditionsList &&
            formData.conditionsList[0] &&
            formData.conditionsList[0]["purchasesAmountCondition"],
        [formData]
    );
    const [criteria, setCriteria] = useState<"numberReservations" | "sumAmount">(
        initialSumAmount
            ? "sumAmount"
            : !initialSumAmount && initialNumberReservations
                ? "numberReservations"
                : "numberReservations"
    );
    const localFormData = cloneDeep(formData);
    const numberReservations = formData?.conditionsList?.find((it: any) =>
        Object.keys(it).includes("purchasesAmountCondition")
    )?.purchasesAmountCondition?.amount;
    const sumAmount = formData?.conditionsList?.find((it: any) =>
        Object.keys(it).includes("spentAmountCondition")
    )?.spentAmountCondition?.amount?.units;

    const handleChange = useCallback(
        (data, type) => {
            let value = data.event.target.value ? Number(data.event.target.value) : 0;
            if (!value) {
                value = 1;
            }

            if (localFormData.conditionsList && localFormData.conditionsList[0][type]) {
                if (type === "spentAmountCondition") {
                    localFormData.conditionsList[0][type].amount.units = value;
                    localFormData.conditionsList[0][type].contextKeysList = ["spentAmount"];
                } else {
                    localFormData.conditionsList[0][type].amount = value;
                    localFormData.conditionsList[0][type].contextKeysList = ["transactionAmount"];
                }
            } else {
                localFormData.conditionsList = [];
                if (type === "spentAmountCondition") {
                    localFormData.conditionsList.push({
                        [type]: {
                            amount: { units: value, currencyCode: currency },
                            contextKeysList: ["spentAmount"],
                        },
                    });
                } else {
                    localFormData.conditionsList.push({
                        [type]: { amount: value, contextKeysList: ["transactionAmount"] },
                    });
                }
            }

            onChange({
                ...localFormData,
                numberReservations: value,
            });
        },
        [onChange, localFormData]
    );

    const handleRadioChange = useCallback(
        event => {
            setCriteria(event.target.value);
            if (
                event.target.value === "numberReservations" &&
                localFormData.conditionsList &&
                localFormData.conditionsList[0]["spentAmountCondition"]
            ) {
                delete localFormData.conditionsList[0]["spentAmountCondition"];
            }
            if (
                event.target.value === "sumAmount" &&
                localFormData.conditionsList &&
                localFormData.conditionsList[0]["purchasesAmountCondition"]
            ) {
                delete localFormData.conditionsList[0]["purchasesAmountCondition"];
            }
            onChange({
                ...localFormData,
            });
        },

        [onChange, localFormData]
    );

    return (
        <>
            <WitLabel>
                <FormattedMessage {...messages.accessLimit} />
            </WitLabel>
            <div>
                <label>
                    <FormattedMessage {...messages.applicableCriteria} />
                </label>
                <Form>
                    <div key={criteria} className="mb-3">
                        <Form.Check
                            inline
                            type={"radio"}
                            id={`numberReservations`}
                            name="group1"
                            value={"numberReservations"}
                            label={intl.formatMessage(messages.numberReservations)}
                            onChange={handleRadioChange}
                            checked={criteria === "numberReservations"}
                        />
                        <Form.Check
                            inline
                            type={"radio"}
                            id={`sumAmount`}
                            name="group1"
                            value={"sumAmount"}
                            label={intl.formatMessage(messages.sumAmount)}
                            onChange={handleRadioChange}
                            checked={criteria === "sumAmount"}
                        />
                    </div>
                </Form>
            </div>

            {criteria === "numberReservations" && (
                <div>
                    <label>
                        <FormattedMessage {...messages.numberReservations} />
                    </label>
                    <InputGroup
                        type="number"
                        value={numberReservations}
                        field={{ fieldName: "numberReservations" }}
                        onChange={data => handleChange(data, "purchasesAmountCondition")}
                        disabled={false}
                        readOnly={false}
                        min={1}
                    />
                </div>
            )}
            {criteria === "sumAmount" && (
                <div>
                    <label>
                        <FormattedMessage {...messages.sumAmount} />
                    </label>
                    <InputGroup
                        type="number"
                        value={sumAmount}
                        field={{ fieldName: "sumAmount" }}
                        onChange={data => handleChange(data, "spentAmountCondition")}
                        disabled={false}
                        readOnly={false}
                    />
                </div>
            )}
        </>
    );
}
